import { useMemo } from 'react';

import { PROJECT_TYPES } from '../constants';
import { ICONS } from '../icons';

const useProjectTypeOptions = () => {
  return useMemo(
    () => [
      {
        label: 'Resonance',
        value: PROJECT_TYPES.RESONANCE,
        icon: ICONS.Resonance,
      },
      {
        label: 'Sonar',
        value: PROJECT_TYPES.SONAR,
        icon: ICONS.Sonar,
      },
      {
        label: 'Scout',
        value: PROJECT_TYPES.SCOUTV2,
        icon: ICONS.Scout,
      },
      {
        label: 'Genie',
        value: PROJECT_TYPES.GENIE,
        icon: ICONS.Genie,
      },
      {
        label: 'GenieGo',
        value: PROJECT_TYPES.GENIE_GO,
        icon: ICONS.Genie,
      },
      {
        label: 'ID8',
        value: PROJECT_TYPES.ID8,
        icon: ICONS.Scout,
      },
      {
        label: 'ACTIV8',
        value: PROJECT_TYPES.ACTIV8,
        icon: ICONS.Activ8,
      },
    ],
    [],
  );
};

export default useProjectTypeOptions;
